<template>
  <b-modal
    ref="bModal"
    size="xs"
    :title="$tc('component.logoutModal.title')"
    centered
    modal-class="modalLogout"
    qa="logout-modal"
  >
    <b-row class="text-center">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <i
          class="main fa-2x far fa-sign-out-alt"
          aria-hidden="true"
        />
        <span class="mt-3">{{ $tc('component.logoutModal.logoutQuestion') }}</span>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide()"
          >
            {{ $tc('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            qa="logoutModal-logout"
            @click="logOut()"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $tc('global.signOut') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { auth } from '@/api/auth'

export default {
    name: 'ModalLogout',
    methods: {
        show() {
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        logOut() {
            auth.logOut()
        }
    }
}
</script>

<style lang="scss">
.modalLogout .modal-body {
  padding: 20px 10px;
}
</style>

<style lang="scss" scoped>
.modalLogout span {
  font-size: font-size(very-normal);
}
</style>
